import MessageTabLabelComponent from "./MessageTabLabelComponent";

export default MessageTabLabelComponent;
